import React from 'react'
import Popup from 'reactjs-popup'

const DescriptionPopup = ({ row }) => (
  <Popup
    trigger={<span>{row.value}</span>}
    on="hover"
    position="bottom left"
    contentStyle={{ whiteSpace: 'pre-wrap', width: 'auto', zIndex: 9 }}
  >
    <div>
      {row.value}
    </div>
  </Popup>
)

export default DescriptionPopup
